const smtpAddress = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

// Custom addresses are addresses that specify a leading routing type, e.g.
// mapidl:123987a987
//
// The routing type can be anything, as it can be configured at a tenant level.
// See #55765 for an example of a customer escalation caused by this.
//
// The route can also be anything, as its format depends on the routing type.
const addressWithCustomRoutingType = /^[A-Za-z0-9_-]+:.*$/;

export function isValidSmtpAddress(emailAddress: string): boolean {
    //VSO: 1041: Separate out form field validation to a different package.
    return smtpAddress.test(emailAddress);
}

export function isAddressWithCustomRoutingType(emailAddress: string): boolean {
    //VSO: 1041: Separate out form field validation to a different package.
    return addressWithCustomRoutingType.test(emailAddress);
}

export default function isValidRecipientAddress(emailAddress: string): boolean {
    //VSO: 1041: Separate out form field validation to a different package.
    return isValidSmtpAddress(emailAddress) || isAddressWithCustomRoutingType(emailAddress);
}
